export default function Footer() {
  return (
    <footer className="relative bg-[#060606] border-t border-[#1f2937] py-8 md:py-10 px-4">
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-5 md:gap-6">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/dc8c408a-3915-4d38-a25e-c286d31ca428.png"
            alt="Super Pack Logo"
            className="h-8 md:h-9 w-auto object-contain"
          />
        </div>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-gray-500 text-sm">
          <a href="#beneficios" className="hover:text-[#8b5cf6] transition-colors cursor-pointer">Herramientas</a>
          <a href="#bonos" className="hover:text-[#8b5cf6] transition-colors cursor-pointer">Bonos</a>
          <a href="#precio" className="hover:text-[#8b5cf6] transition-colors cursor-pointer">Precio</a>
          <a href="#como-acceder" className="hover:text-[#8b5cf6] transition-colors cursor-pointer">¿Cómo acceder?</a>
          <a href="#faq" className="hover:text-[#8b5cf6] transition-colors cursor-pointer">FAQ</a>
        </div>

        {/* Copyright */}
        <p className="text-gray-600 text-xs text-center">
          © {new Date().getFullYear()} Super Pack Digital. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
